import { render, staticRenderFns } from "./dealsHoverDialog.vue?vue&type=template&id=36fca5e0&lang=pug"
import script from "./dealsHoverDialog.vue?vue&type=script&lang=js"
export * from "./dealsHoverDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports